<mat-sidenav-container [hasBackdrop]="false"
                       (backdropClick)="handleGracefulClose()"
                       class="body-1-regular-1">
  <mat-sidenav #sidenavRight mode="over" position="end"
               class="admin-feature-sidenav-no-scrollbar"
               [fixedInViewport]="true"
               [fixedTopGap]="0"
               [fixedBottomGap]="0"
               [opened]="false"
               (keydown.escape)="handleGracefulClose()"
               disableClose
               style="width: 500px">
    @if (selectedRoleGroupRow) {
      <mat-toolbar>
        <button mat-icon-button (click)="handleGracefulClose()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span>{{ selectedRoleGroupRow.roleName }}</span>
        <span class="fx-spacer"></span>

        @if(selectedRoleGroupRow.elevationLevel == GroupedRoleElevationLevel.INTERNAL_ADMIN ){
          <mat-chip class="grants-role-groups-role-elevation-chip">{{ selectedRoleGroupRow.elevationLevel}}</mat-chip>
        }
      </mat-toolbar>

      <div class="pl-16 pr-16">
        <app-crud-table
          title='MEMBER ROLES'
          longDescription='The following roles are members of this group. All users that are granted access to this group will get access to all the following roles'
          [modelType]="memberRolesModelType"
          [loading$]="loading$"
          [tableData]="selectedRoleGroupRow.memberRoles"
          [displayColumns]="memberRolesModelTypeDisplayCols"
          [showLoaderBars]="false"
          filterType="NONE"
        ></app-crud-table>
        <!-- on row selected: open dialog with full description-->

        @if (addGrantRequest) {
          <app-crud-item
            title="Add user to role group"
            longDescription="Grant access to a user, this will grant the user access to the role as well as to the offering and property. Note: After granting the user access, the system will automatically send a notification to the user with their login details. The user will have to reset their password in order to log in for the first time."
            submitMode="LOCAL"
            [(data)]="addGrantRequest"
            [modelType]="addGrantModelType"
            [enableCancelButton]="true"
            (onFormSubmitted)="handleAddUserGrantFormSubmission($event)"
            (updateCanceled)="handleUpdateCanceled($event)"
          >
          </app-crud-item>
        } @else if (grantedUsers) {
          <app-crud-table
            title='GRANTS'
            subTitle='Users with access'
            [modelType]="grantsModelType"
            [loading$]="loading$"
            [tableData]="grantedUsers"
            [additionalActions]="grantsAdditionalActions"
            (rowSelected)="grantedUserRowSelected($event)"
            [updatedRow]="addGrantRequestUpdated"
            [showLoaderBars]="false"
          >
          </app-crud-table>
        }
      </div>
    } @else {
      No data selected
    }
  </mat-sidenav>


  <mat-sidenav-content>
    <div class="fx-col fx-gap-20">

      @if (isInternalUser) {
        <div class="fx-row fx-gap-20">
          <button (click)="toggleAddGrantsDialog()" class="button-action" mat-flat-button
                  [disabled]="!!(loading$ | async)">
            <div class="button-text">Add grant</div>
          </button>
        </div>
      }

      @for (moduleGroup of roleGroupModules; track moduleGroup) {
        @if (shouldRenderModuleGroup(moduleGroup.moduleGroupCode)) {
          <app-crud-table
            [title]="getModuleDef(moduleGroup.moduleGroupCode)?.title ?? 'ROLE GROUPS'"
            [subTitle]="getModuleDef(moduleGroup.moduleGroupCode)?.description ?? null"
            [modelType]="principleRoleGroupModelType"
            [tableData]="moduleGroup.principleRoleGroups"
            [interruptPendingChanges]="pendingChanges"
            [unselectRow]="shouldClearRow(moduleGroup)"
            [showLoaderBars]="false"
            (rowSelected)="principleRoleGroupsRowSelected($event, moduleGroup)"
          ></app-crud-table>

          <mat-divider></mat-divider>
        }
      }
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>
